import { api } from "./api";

export const CreateCategory = (data) => {
  return api.post(`document/category/add`, data);
};

export const fetchCategories = (addUrl = "") => {
  let url = `/document/category/list?${addUrl}`;
  return api.get(url);
};

export const fetchDoc = (addUrl = "") => {
  let url = `/document/list?${addUrl}`;
  return api.get(url);
};

export const updateCategory = (data) => {
  return api.post(`/document/category/status/update`, data);
};

export const GetAllTypeStudent = (addUrl = "") => {
  let url = `document/all/student/type?${addUrl}`;
  return api.get(url);
};

export const documentUpload = (data) => {
  return api.post(`/document/add`, data);
};

export const DistributionAdd = (data) => {
  return api.post(`/document/distribution/add`, data);
};

export const DistributionList = (addUrl = "") => {
  let url = `document/distribution/list?${addUrl}`;
  return api.get(url);
};

export const Distributionupdate = (data) => {
  return api.post(`document/distribution/collect/update`, data);
};

export const Distributiondelete = (data) => {
  return api.post(`document/distribution/delete`,data);
};



export const DistributionAlreadyGiven = (params) => {
  return api.get("document/distribution/already-given", { params });
};
